/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionPaymentRefundQuery from '../graphql/queries/GetSouscriptionPaymentRefundQuery.js';

const useGetSouscriptionPaymentRefundQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionPaymentRefundQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionPaymentRefund: R.omit(['__typename'], data?.getSouscriptionPaymentRefund_souscription_payment_refund || {})
  };
};

export default useGetSouscriptionPaymentRefundQuery;
